import React, { useState } from 'react';
import Select from './Select';
import Input from './Input';
import Option from './Option';
import Options from './Options';
import { getTranslateLang } from "../services/Translates";

let Filters = ( props ) => {

    const [ country, setCountry ]                    = useState(null);
    const [ street, setStreet ]                      = useState(null);
    const [ radius, setRadius ]                      = useState(false);
    const [ radiusValue, setRadiusValue ]            = useState('');
    const [ additional, setAdditional ]              = useState(false);
    const [ additionalArray, setAdditionalrray ]     = useState([]);

    let checkInArray = (id) => {
        if( additionalArray.includes(id) ) return true;
        else return false
    } 

    let checkSendAdditionalArray = (id) => {
        let check = additionalArray.indexOf(id);
        let copy = additionalArray;

        if( check > -1) {
            copy.splice(check, 1);
        } else {
            copy = [ ...copy, id];
        }

        setAdditionalrray(copy);
        props.checkedOptions(copy);
    }
    let scrollToMap = () => {
        // check width 
        if ( window ) {
            let width = window.innerWidth;
            if ( width < 760 ) {
                let map = document.getElementById('main-map');
                window.scroll({
                    behavior: 'smooth',
                    left: 0,
                    top: map.offsetTop
                  });
            }
        }
    } 
    return (
        <div className="filters">

            <Select name="choose-country" 
                    default_option={ getTranslateLang('wszystkie') } 
                    options={ props.countries } 
                    setFunction={ (val) => { setCountry(val); props.changeCountry(val) } } 
                    required={ false } 
                    title={ getTranslateLang('kraj') }  />

            <h2>{ getTranslateLang('znajdz_myjnie') }</h2>

            <Input name="street"
                   placeholder={ getTranslateLang('miejscowosc_ulica') }
                   required={ false }
                   type="text"
                   pattern=""
                   setFunction={ (val) => { setStreet(val); } }
                   setBlur={ (val) => props.changeStreet(val) } />
            
            <div className="column">
                <div className="radius">
                    <Option title={ getTranslateLang('szukaj_w_promieniu') } 
                            value={ radius }
                            setFunction={ (val) => setRadius(val) } />
                    <Input  name="radius-value"
                            placeholder={ props.radius + " km"}
                            required={ false }
                            type="number"
                            disabled={ (!street || street.length == 0 ? true : false) }
                            setBlur={ (val) => { setRadiusValue(val); props.setRadius(val) } }
                            setFunction={ () => { return false} } />
                </div>
            </div>
            <div className="button-more">
                <button onClick={ () => setAdditional(!additional) } className={"btn-more " + ( additional ? 'active' : '' ) } >{ getTranslateLang('opcje') } </button>
            </div>
            { additional && 
                <div className="additional">
                    { props.options && props.options.map( (item, index) => (
                        <Options
                                key={ index } 
                                title={ item.translate }
                                value={ item.id } 
                                checked={ (val) => checkInArray(val) }
                                icon={ item.img }
                                setFunction={ (val) => checkSendAdditionalArray(val) } />
                    ))}
                </div>
            }
            <div className="button-search">
                <button className="btn-search" onClick={ () => { props.search(); setAdditional(false); } }>{ getTranslateLang('szukaj') } </button>
            </div>
            { !additional && 
            <div className="nearby-realizations">
            
            { props.realizationsNear && props.realizationsNear.map( el => (
                    <div className="realization">
                                <div className="img">
                                    <img src={ props.iconList } alt="BKF" />
                                </div>
                                <div className="info">
                                    <p><b>{ el[0].device_name }</b></p>
                                    {/* { el[0].device_address && 
                                        <p>{ el[0].device_address } </p>
                                    }
                                    { !el[0].device_address && 
                                        <p>Brak adresu</p>
                                    } */}
                                    <span>{el[0].device_latitude}, {el[0].device_longitude} </span>
                                    <p className="link" onClick={ () => { props.seeOnMap(el[0].device_latitude, el[0].device_longitude, el[0].device_id); scrollToMap();} }>{ getTranslateLang('zobacz_na_mapie') }</p>
                                </div>
                                <div className="distance">
                                    <p>{ el[0].distance } km</p>
                                </div>
                            </div>
                    ))
                    
                    }
                </div>
            }
            
        </div>
    )
}

export default Filters;
